// GENERATED by `npm run schema` (web/tools/gen-schema.ts) from shared/data/*.json. Do not edit:
// change the JSON and rerun. Id unions for the sim (IMPLEMENTATION §0.5); arrays are in data order.

/** Content versions, oldest first. */
export const VERSIONS = ['0.1', '0.2'] as const;
export type Version = (typeof VERSIONS)[number];

/** Item families (items.json). */
export const FAM_IDS = [
  'ore_lead',
  'ore_coal',
  'ore_copper',
  'ore_iron',
  'slug',
  'powder',
  'cbar',
  'casing',
  'sbar',
  'barrel',
  'frame',
  'ammo',
  'gun',
] as const;
export type FamId = (typeof FAM_IDS)[number];

/** Item kinds. */
export const KINDS = ['ore', 'part', 'stock', 'ammo', 'gun'] as const;
export type Kind = (typeof KINDS)[number];

/** Materials tracked by the conservation ledger. */
export const MATS = ['lead', 'coal', 'copper', 'iron'] as const;
export type Mat = (typeof MATS)[number];

/** Deposit ores (deposits.json). */
export const ORE_IDS = ['lead', 'coal', 'copper', 'iron'] as const;
export type OreId = (typeof ORE_IDS)[number];

/** Building types (deposit + machines.json). */
export const BTYPES = [
  'deposit',
  'drill',
  'crate',
  'chute',
  'caster',
  'grinder',
  'smelter',
  'press',
  'loader',
  'packer',
  'gallery',
  'gunsmith',
  'dock',
] as const;
export type BType = (typeof BTYPES)[number];

/** Recipes (recipes.json). */
export const RECIPE_IDS = [
  'cast',
  'grind',
  'smelt_cu',
  'smelt_fe',
  'press_casing',
  'press_barrel',
  'press_frame',
  'load',
  'assemble',
] as const;
export type RecipeId = (typeof RECIPE_IDS)[number];

/** Stall reasons (stalls.json). */
export const STALL_IDS = [
  'NO_ROOM',
  'NO_INPUT',
  'NO_HEAT',
  'MISMATCH',
  'CRATE_FULL',
  'NO_TARGET',
  'VEIN_BLOCKED',
  'WRONG_ITEM',
  'GHOST',
  'PAUSED',
  'NO_GUN',
  'WRONG_MODE',
  'GUN_TOO_BIG',
] as const;
export type StallId = (typeof STALL_IDS)[number];

/** Unlocks in firing order (unlocks.json). */
export const UNLOCK_IDS = [
  'u00',
  'u01',
  'u02',
  'u03',
  'u04',
  'u05',
  'u06',
  'u07',
  'u08',
  'u09',
  'u10',
  'u11',
  'u12',
  'u13',
  'u14',
  'u15',
  'u16',
  'u17',
  'u18',
  'u19',
  'u20',
  'u21',
  'u30',
  'u31',
  'u32',
  'u33',
  'u34',
  'u35',
  'u36',
  'u37',
] as const;
export type UnlockId = (typeof UNLOCK_IDS)[number];

/** Priced shop entries (deposits, buildings). */
export const SHOP_IDS = [
  'deposit.lead',
  'deposit.coal',
  'deposit.copper',
  'deposit.iron',
  'drill',
  'crate',
  'chute',
  'caster',
  'grinder',
  'smelter',
  'press',
  'loader',
  'packer',
  'gallery',
  'gunsmith',
  'dock',
] as const;
export type ShopId = (typeof SHOP_IDS)[number];

/** Board masks, starting mask first. */
export const EXPANSION_IDS = ['3x3', '5x5', '5x7', '7x7', '7x9'] as const;
export type ExpansionId = (typeof EXPANSION_IDS)[number];

/** Unlock effects. */
export const EFFECT_IDS = [
  'gallery.practice',
  'deposit.lead.rise',
  'counter',
  'shop',
  'shop.deposit.lead',
  'buildMode',
  'hint.hold',
  'build.crate',
  'quickMerge',
  'build.caster',
  'build.drill',
  'build.chute',
  'expansion.5x5',
  'shop.deposit.coal',
  'build.grinder',
  'shop.deposit.copper',
  'mergeAll',
  'build.smelter',
  'smelter.mode.copper',
  'build.press',
  'press.mode.casing',
  'build.loader',
  'gallery.factoryFeed',
  'hint.machineMerge',
  'chip.bottleneck',
  'bench',
  'offline',
  'music',
  'build.packer',
  'expansion.5x7',
  'hud.autoIncome',
  'v01Complete',
  'telemetry.exportPrompt',
  'shop.deposit.iron',
  'smelter.mode.iron',
  'press.mode.barrel',
  'press.mode.frame',
  'press.mode.alternate',
  'build.gunsmith',
  'build.gallery',
  'gallery.merge',
  'build.dock',
  'expansion.7x7',
  'expansion.7x9',
  'v02Complete',
] as const;
export type EffectId = (typeof EFFECT_IDS)[number];

/** Tutorial tips in order (unlocks.json tutorial). */
export const TIP_IDS = [
  'tapToFire',
  'tapVein',
  'mergeToMakeRoom',
  'dragToSell',
  'dropOnVein',
  'holdToDig',
  'pickChute',
] as const;
export type TipId = (typeof TIP_IDS)[number];
